<template>
  <b-container fluid>
    <section>
      <b-row>
        <b-col cols="12">
          <b-modal id="modal-1" title="Join Our Beta">
            <Mailchimp />
          </b-modal>
        </b-col>
      </b-row>
    </section>
  </b-container>
</template>
<script>
import Mailchimp from '~/components/landingPage/Mailchimp.vue'

export default {
  components: {
    Mailchimp
  }
}
</script>
